import {
  OfferOption,
  OfferOptionsMapping,
  OfferOptionType,
  OfferOptionUsageType,
} from '../../OfferOptionsMappings/Types/offerOptionsMappingsTypes';

export function toMappingIds(selected: OfferOption[], mappings: OfferOptionsMapping[]): number[] {
  const additionalIndex = new Map<string, number>(
    mappings
      .filter((m) => m.usageType === OfferOptionUsageType.Additional)
      .map((m) => [`${m.offerOptionsTypeId}:${m.offerOptionsValueId}`, m.offerOptionMappingId])
  );

  return selected
    .map((sel) => additionalIndex.get(`${sel.offerOptionsTypeId}:${sel.offerOptionsValueId}`))
    .filter((id): id is number => id !== undefined);
}

export function buildOptionTypesForField(
  allTypes: OfferOptionType[],
  mappings: OfferOptionsMapping[]
): OfferOptionType[] {
  const additionalMappings = mappings.filter((m) => m.usageType === OfferOptionUsageType.Additional);
  const typeIds = new Set(additionalMappings.map((m) => m.offerOptionsTypeId));
  const additionalKeys = new Set(
    additionalMappings.map((m) => `${m.offerOptionsTypeId}:${m.offerOptionsValueId}`)
  );

  return allTypes
    .filter((t) => typeIds.has(t.id))
    .map((t) => ({
      ...t,
      offerOptionsValues: t.offerOptionsValues.filter(
        (v) => (v.value || v.shortName) && additionalKeys.has(`${t.id}:${v.id}`)
      ),
    }));
}
